export default __webpack_public_path__ + "img/e6c5aff820ce4db2bd4aa71831ef4c16.png";